import {
  ExperiencesAvailabilityAutocompleteRequest,
  ExperiencesAvailabilityAutocompleteResponse,
} from "redmond";
import { put, select } from "redux-saga/effects";
import { IStoreState } from "../../../reducers/types";
import { actions } from "../actions";
import Logger from "../../../utils/logger";
import { getLocation } from "../../search/reducer";
import { getEncodedTags } from "../reducer";
import { fetchExperiencesAvailabilityAutocomplete } from "../../../api/v0/availability/fetchExperiencesAvailabilityAutocomplete";
import { setExperiencesAvailabilityAutocomplete } from "../actions/actions";
import { getSelectionId } from "../../../utils/selectionHelpers";

export function* fetchExperiencesAvailabilityAutocompleteSaga(
  action: actions.IFetchExperiencesAvailabilityAutocomplete
) {
  try {
    let requestBody: ExperiencesAvailabilityAutocompleteRequest;
    const state: IStoreState = yield select();

    const location = getLocation(state);
    const destinationId = location?.id ? getSelectionId(location.id) : "";

    requestBody = {
      destination: destinationId,
      query: action.queryString,
      encodedTags: getEncodedTags(state),
    };

    let availabilityAutocompleteResponse: ExperiencesAvailabilityAutocompleteResponse =
      yield fetchExperiencesAvailabilityAutocomplete(requestBody);

    yield put(
      setExperiencesAvailabilityAutocomplete(availabilityAutocompleteResponse)
    );
  } catch (e) {
    Logger.debug(e);
  }
}
